// extracted by mini-css-extract-plugin
export default {"link":"bE-z","disabled":"cE-z"};